import { useEffect, useRef } from 'react';
import renderFramingChart from './renderFramingChart';
import { FramingChartProps } from './types';
import styles from './FramingChart.module.css';

export default function FramingChart(props: FramingChartProps) {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const canvas = canvasRef.current;

    if (canvas) {
      renderFramingChart(canvas, props);
    }
  }, [props]);

  return (
    <>
      <canvas ref={canvasRef} className={styles.framingChartCanvas} />
    </>
  );
}
